export default __webpack_public_path__ + "static/media/nft-4.cb0cac52.png";